import { type RemoteTimezone } from '@/lib/utils/dates';
import { type UrlEntry, type UrlRegion } from '@/types';

import type { HomeParamsParsed, PageParams } from './page';

export const urls: Record<'home', Record<UrlRegion, UrlEntry>> = {
  home: {
    de: '',
    'de-en': '',
    es: '',
    'es-en': '',
    fr: '',
    'fr-en': '',
    gb: '',
    nl: '',
    'nl-en': '',
    pt: '',
    'pt-en': '',
    us: '',
    ww: '',
  },
};

export const parseParams = (params: PageParams) => {
  const { extraParams = [], ...initialParsedParams } = params;

  return (extraParams as string[]).reduce<HomeParamsParsed>(
    (parsedParams, pathPart, index) => {
      if (pathPart === 'user-country') {
        return {
          ...parsedParams,
          userCountry: extraParams[index + 1],
        };
      } else if (pathPart === 'timezone') {
        return {
          ...parsedParams,
          timezone: extraParams[index + 1].replace('-', '/') as RemoteTimezone,
        };
      }
      return parsedParams;
    },
    initialParsedParams
  );
};
